export const insertElement = (arr, item, at) => {
  if (!Array.isArray(item) && typeof item === "object") {
    arr.splice(at, 0, { ...item });
  } else if (Array.isArray(item)) {
    arr.splice(at, 0, [...item]);
  } else {
    arr.splice(at, 0, item);
  }
};

export const deleteElement = (arr, at) => {
  arr.splice(at, 1);
};

export const updateIndexList = (list, at, by) => {
  const newList = Array.from(list).map((i) => {
    if (i >= at) {
      return i + by;
    } else return i;
  });
  return new Set(newList);
};

/**
 * Returns whether a value is meaningfully "set" — not undefined, not null, and not an empty string.
 * @param {*} value The value to check.
 * @returns {boolean}
 */
export const hasValue = (value) => {
  return value !== undefined && value !== null && value !== "";
};

/**
 * Returns whether two values represent the same underlying value once both have a value and are
 * compared as strings (useful for comparing IDs that may come through as either a number or string).
 * @param {*} lhs
 * @param {*} rhs
 * @returns {boolean}
 */
export const isSameValue = (lhs, rhs) => {
  return hasValue(lhs) && hasValue(rhs) && lhs.toString() === rhs.toString();
};
